var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, ElementRef, OnChanges } from '@angular/core';
import { ChartType } from '../../base-chart';
import { ChartistLine } from '../../chartist/chartist-line';
import { ChartistPie } from '../../chartist/chartist-pie';
var ChartComponent = /** @class */ (function () {
    function ChartComponent() {
    }
    Object.defineProperty(ChartComponent.prototype, "hostClass", {
        get: function () {
            return (this.chartConfig ? this.chartConfig.type : '') + '-chart-container';
        },
        enumerable: true,
        configurable: true
    });
    ChartComponent.prototype.ngOnChanges = function () {
        if (!this.chartConfig)
            return;
        if (this.chartConfig.type === ChartType.LINE) {
            this.chart = new ChartistLine(this.transformConfig());
        }
        else {
            this.chart = new ChartistPie(this.transformConfig());
        }
    };
    ChartComponent.prototype.ngOnDestroy = function () {
        if (!this.chart)
            return;
        this.chart.destroy();
    };
    ChartComponent.prototype.transformConfig = function () {
        return __assign({}, this.chartConfig, { selector: this.chartPlaceholder.nativeElement });
    };
    return ChartComponent;
}());
export { ChartComponent };
